import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class DataLayer {}
_defineProperty(DataLayer, "trackEvent", event => {
  if (typeof window.dataLayer === 'undefined') {
    window.dataLayer = [event];
  } else {
    window.dataLayer.push(event);
  }
});